<template>
    <div>
      <div class="vx-card">
        <div class="vx-card__body card-body p-10">
          <upload-popup
            :show="uploadPopup"
            @close="uploadPopup = false"
            @success="renderGrid"
            :attachmentTypes="attachmentTypes"
            :contentItemId="modelToEdit"
          >
          </upload-popup>
          <ImagePopup
            v-if="imagePopup"
            :show="imagePopup"
            :image="selectedImage"
            @close="imagePopup = false"
          ></ImagePopup>
          <div class="mb-24">
            <div class="flex justify-end">
              <a
                style="background-color: #14a577"
                class="flex items-center justify-center gap-4 w-48 h-10 rounded-lg text-white cursor-pointer mb-6"
                @click.prevent="uploadPopup = true"
              >
                {{ $t("UploadAttachment")
                }}<i class="material-icons notranslate"> cloud_upload </i>
              </a>
            </div>
            <div class="flex flex-row flex-wrap">
              <div v-if="imageAttached && imageAttached.length===0">
                  {{ $t("NoRecordsFound")
                }}
                  
              </div>
              <div v-for="row in imageAttached" class="">
                <div class="border-solid p-5 m-5">
                  <img
                    :src="
                      URLS_CONSTANTS.assets + 'PettyCashTransactions/' + row.uri
                    "
                    style="max-height: 100px"
                    class="rounded cursor-pointer"
                    @click.prevent="
                      showImagePopup(
                        URLS_CONSTANTS.assets + 'PettyCashTransactions/' + row.uri
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { mapGetters, mapActions } from "vuex";
  
  import { URLS_CONSTANTS } from "@/../config";
  import myUpload from "vue-image-crop-upload";
  import DataGrid from "@/components/datagrid/DataGrid";
  import UploadPopup from "./UploadPopup.vue";
  import ImagePopup from "@/components/ImagePopup.vue";
  
  export default {
    data() {
      return {
        popupTitle: "",
        attachmentTypes: [
          { label: "عکس کاور", id: 1 },
          { label: "عکس کاور موبایل", id: 2 },
          { label: "عکس آیکون", id: 3 },
          // { label: "فایل", id: 4 },
        ],
        gridDataSource: {
          type: "app",
          service: `Credits/api/PettyCashTransactionQuery/all-files/by/${this.$route.params.id}`,
        },
  
        uploadPopup: false,
        URLS_CONSTANTS,
        imagePopup: false,
        selectedImage: "",
        modelToEdit: this.$route.params.id,
        imageAttached: [],
      };
    },
    components: {
      myUpload,
      DataGrid,
      UploadPopup,
      ImagePopup,
    },
    mounted() {
      this.getData();
    },
    methods: {
      ...mapActions({
        fetchAttachment: "pettyCash/fetchAttachment",
      }),
      getData() {
        this.fetchAttachment(this.modelToEdit).then((result) => {
          this.imageAttached = result;
        });
      },
  
      renderGrid() {
        this.getData();
      },
      showImagePopup(image) {
        this.selectedImage = image;
        this.imagePopup = true;
      },
    },
    watch: {
      // show() {
      //   if (this.show) {
      //     this.popupTitle = "پیوست‌های آیتمِ " + this.modelToEdit.title;
      //     this.gridDataSource.service = `/CMS/api/ContentImageQuery?contentId=${Number(
      //       this.$route.params.id
      //     )}&contentItemId=${this.modelToEdit.id}&`;
      //     this.showGrid = true;
      //   } else {
      //     this.showGrid = false;
      //   }
      // },
    },
  };
  </script>
  